import { render } from "./UserLicense.vue?vue&type=template&id=3db58343&ts=true"
import script from "./UserLicense.vue?vue&type=script&lang=ts"
export * from "./UserLicense.vue?vue&type=script&lang=ts"

import "./UserLicense.vue?vue&type=style&index=0&id=3db58343&lang=scss"

import exportComponent from "/home/runner/work/on-the-edge-admin/on-the-edge-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__